import React, {useState, useEffect} from "react";

import {DoubleRightOutlined, DoubleLeftOutlined} from "@ant-design/icons";
import {Switch} from "antd";

import {MapTools, AnalysisPanelButton, AnalysisPanelContainer} from "../H3Map.styles";
import {ResolutionSelector} from "./ResolutionSelector";
import {HexagonList} from "./HexagonList";
import {H3MapConfig} from "../config";
import {
    Container,
    FlexColumn,
    HexagonHeader,
    HexagonTitle,
    HexagonCount,
    IconText,
    OtherHexagonsContainer,
    OtherHexagonsHeader,
    ColorLabelContainer,
    ColorSquare,
    LabelText
} from "./H3MapTools.styles";

export const H3MapTools = ({
    resolution,
    setResolution,
    resolutionOptions,
    totalHexagons,
    hexagonsByResolution,
    markerH3Indexes,
    handleListItemClick,
    handleMarkerZoom,
    markerColor,
    isVisible,
    setIsVisible,
    disabledResolutions = [],
    hoverHexagon,
    setHoverHexagon,
    onHexagonDelete,
    isActionsEnabled = false,
    onlyH3Resolutions = false,
    showOtherHexagons,
    setShowOtherHexagons,
    otherHexagons = []
}) => {
    const filteredResolutionOptions = onlyH3Resolutions
        ? resolutionOptions.filter(option =>
              Object.keys(hexagonsByResolution).includes(String(option.value))
          )
        : resolutionOptions;
    const currentResOption = filteredResolutionOptions.find(option => option.value === resolution);
    const [expandedSections, setExpandedSections] = useState({});
    const [selectedHex, setSelectedHex] = useState(null);

    useEffect(() => {
        const initialState = {};
        Object.keys(hexagonsByResolution).forEach(res => {
            initialState[res] = true;
        });
        setExpandedSections(initialState);
    }, [hexagonsByResolution]);

    function toggleSection(res) {
        setExpandedSections(prev => ({
            ...prev,
            [res]: !prev[res]
        }));
    }

    function handleHexClick(hex, res) {
        handleListItemClick(hex, res);
    }

    function toggleCompanyList(hex) {
        setSelectedHex(selectedHex === hex ? null : hex);
    }

    function OtherHexagonsSection() {
        return (
            <OtherHexagonsContainer>
                <OtherHexagonsHeader>
                    <ColorLabelContainer>
                        <ColorSquare color={H3MapConfig.hexagons.OTHER.color} />
                        <LabelText>Diğer Hexagonları Göster</LabelText>
                    </ColorLabelContainer>
                    <Switch
                        checked={showOtherHexagons}
                        onChange={setShowOtherHexagons}
                        size="small"
                    />
                </OtherHexagonsHeader>
            </OtherHexagonsContainer>
        );
    }

    return (
        <Container $isVisible={isVisible}>
            <AnalysisPanelButton
                onClick={() => setIsVisible(!isVisible)}
                $isVisible={isVisible}
                type="button"
            >
                {isVisible ? (
                    <DoubleLeftOutlined style={{fontSize: "14px", color: "#111"}} />
                ) : (
                    <div style={{display: "flex", alignItems: "center", gap: "6px"}}>
                        <DoubleRightOutlined style={{fontSize: "16px", color: "#111"}} />
                        <IconText>Analiz Paneli</IconText>
                    </div>
                )}
            </AnalysisPanelButton>
            {isVisible && (
                <MapTools>
                    <AnalysisPanelContainer>
                        <FlexColumn>
                            <ResolutionSelector
                                resolution={resolution}
                                setResolution={setResolution}
                                resolutionOptions={filteredResolutionOptions}
                                currentResOption={currentResOption}
                                isActionsEnabled={isActionsEnabled}
                            />

                            {otherHexagons?.length > 0 && <OtherHexagonsSection />}

                            {totalHexagons > 0 && (
                                <FlexColumn>
                                    <HexagonHeader>
                                        <HexagonTitle>Seçili Hexagonlar</HexagonTitle>
                                        <HexagonCount>{totalHexagons}</HexagonCount>
                                    </HexagonHeader>
                                    <HexagonList
                                        hexagonsByResolution={hexagonsByResolution}
                                        resolutionOptions={resolutionOptions}
                                        markerH3Indexes={markerH3Indexes}
                                        selectedHex={selectedHex}
                                        expandedSections={expandedSections}
                                        handleHexClick={handleHexClick}
                                        toggleSection={toggleSection}
                                        toggleCompanyList={toggleCompanyList}
                                        handleMarkerZoom={handleMarkerZoom}
                                        setResolution={setResolution}
                                        disabledResolutions={disabledResolutions}
                                        markerColor={markerColor}
                                        hoverHexagon={hoverHexagon}
                                        setHoverHexagon={setHoverHexagon}
                                        onHexagonDelete={onHexagonDelete}
                                        isActionsEnabled={isActionsEnabled}
                                    />
                                </FlexColumn>
                            )}
                        </FlexColumn>
                    </AnalysisPanelContainer>
                </MapTools>
            )}
        </Container>
    );
};
